import { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { WhatsApp } from "@mui/icons-material";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronRightIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { DefaultInput } from "../../../inputs/DefaultInput";
import { ColombiaIconInput } from "../../../inputs/CoIombiaIconInput";
import { VerifyNewWhatsApp } from "./VerifyNewWhatsApp";
import { AuthService } from "../../../../services/auth/auth.service";
import { PrimaryMobile } from "../../../buttons/mobile/Primary";
import { TYPUpdate } from "./TYPUpdate";
import { sanitizarInputNumerico } from "../../../../utils/validateData";
import { validarLongitudMaxima } from "../../../../utils/validacionesForms";

export function UpdateWhatsApp() {
  const [open, setOpen] = useState(false);
  const [phoneInput, setPhoneInput] = useState("");
  const [showError, setShowError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [showViewVerifyOtp, setShowViewVerifyOtp] = useState(false);
  const [showSuccessView, setShowSuccessView] = useState(false);
  const [otpInput, setOptInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);

  const handleChange = (e) => {
    const value = sanitizarInputNumerico(e.target.value);
    setPhoneInput(value);
  };

  const handleClosePanel = () => {
    setOpen(false);
    setPhoneInput("");
    setMessageError("");
    setShowViewVerifyOtp(false);
    setShowError(false);
  };

  const toggleShowViewVerifyOtp = () => {
    setShowViewVerifyOtp(!showViewVerifyOtp);
  };

  const handleSubmitVerifyPhone = async () => {
    const MAX_ACCOUNT_LENGTH = 10;
    if (validarLongitudMaxima(phoneInput, MAX_ACCOUNT_LENGTH) === false) {
      setShowError(true);
      setMessageError(`El número de teléfono no puede superar los ${MAX_ACCOUNT_LENGTH} dígitos.`);
      return;
    }

    const soloNumerosRegex = /^[0-9]+$/;
    if (!soloNumerosRegex.test(phoneInput)) {
      setShowError(true);
      setMessageError("Datos de teléfono inválidos.");
      return;
    }

    if (phoneInput === localStorage.getItem("phone")) {
      setShowError(true);
      setMessageError("El número debe ser diferente al que está registrado.");
      return;
    }

    setShowError(false);
    setMessageError("");
    setDisabledBtn(true);
    setIsLoading(true);

    try {
      let { message, error, code } =
        await AuthService.confirmPhoneToUpdatePhone({
          documento: localStorage.getItem("doc"),
          phone: phoneInput,
        });

      if (error) {
        if (code === 500) {
          setMessageError("Ocurrió un error interno, intenta más tarde!");
        }
        if (code === "ERR_BAD_REQUEST") {
          setMessageError(
            "Ocurrió un error. Valida los datos e intenta nuevamente.",
          );
        }
        if (message && message?.code && message.code === "PHONE_EXISTS") {
          setMessageError(
            "El número de teléfono ingresado ya existe, por favor verifica.",
          );
        }
        setShowError(true);
        return;
      }

      if (message && message?.success && message.success === true) {
        setShowViewVerifyOtp(true);
        return;
      } else {
        setShowError(true);
        setMessageError(
          "Ocurrió un error interno, Valida los datos e intenta nuevamente.",
        );
      }
    } catch (error) {
      console.log(error);
      setShowError(true);
      setMessageError("Ocurrió un error interno, intenta más tarde!");
    } finally {
      setDisabledBtn(false);
      setIsLoading(false);
    }
  };

  const handleSubmitVerifyOtp = async () => {
    const MAX_ACCOUNT_LENGTH = 6;
    if (validarLongitudMaxima(otpInput, MAX_ACCOUNT_LENGTH) === false) {
      setShowError(true);
      setMessageError(`El código OTP no puede superar los ${MAX_ACCOUNT_LENGTH} dígitos.`);
      return;
    }

    const soloNumerosRegex = /^[0-9]+$/;
    if (!soloNumerosRegex.test(otpInput)) {
      setShowError(true);
      setMessageError("Datos de OTP inválidos.");
      return;
    }

    setShowError(false);
    setMessageError("");
    setDisabledBtn(true);
    setIsLoading(true);

    try {
      let { message, error, code } = await AuthService.confirmOtpToUpdatePhone({
        documento: localStorage.getItem("doc"),
        newPhone: phoneInput,
        otp: otpInput,
      });
      if (error) {
        setShowError(true);
        if (code === 500) {
          setMessageError("Ocurrió un error interno, intenta más tarde!");
        }

        if (code === 400) {
          setMessageError(
            "Ocurrió un error interno, Valida los datos e intenta nuevamente.",
          );
        }
        if (message.code === "INVALIDOTP") {
          setMessageError("El código OTP ingresado no es válido.");
        }
        return;
      }

      if (message && message?.success && message.success === true) {
        setShowViewVerifyOtp(false);
        setShowSuccessView(true);
        localStorage.setItem("phone", phoneInput);
        return;
      } else {
        setShowError(true);
        setMessageError(
          "Ocurrió un error interno, Valida los datos e intenta nuevamente.",
        );
      }
    } catch (error) {
      console.log(error);
      setShowError(true);
      setMessageError("Ocurrió un error interno, intenta más tarde!");
    } finally {
      setDisabledBtn(false);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className={"w-full"} onClick={() => setOpen(true)} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between">
            <div className="flex gap-2 py-1">
              <div className="w-5 h-auto xl:w-6">
                <WhatsApp />{" "}
              </div>
              <div className="pl-4">WhatsApp</div>
            </div>
            <div className="grid content-center">
              <ChevronRightIcon className="w-5 h-auto" />
            </div>
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={handleClosePanel} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 transition-opacity duration-200 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div>
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClosePanel}
                            className="relative text-white focus:outline-hidden"
                            style={{cursor: "pointer"}}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">WhatsApp</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClosePanel}
                            className="relative text-white focus:outline-hidden"
                            style={{cursor: "pointer"}}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          Confirmanos tu nuevo WhatsApp
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white p-4">
                    <div className="text-grayP py-4">
                      Te enviaremos un código OTP de 6 dígitos a tu nuevo
                      WhatsApp para verificar que esté correcto
                    </div>
                    <div className="flex gap-2">
                      <ColombiaIconInput />
                      <DefaultInput
                        value={phoneInput}
                        onChange={handleChange}
                        autoFocus={true}
                        type={"tel"}
                        name={"WhatsApp"}
                        id={"WhatsApp"}
                        autoComplete={"on"}
                        spellCheck={true}
                        required={true}
                        minLength={"10"}
                        maxLength={"10"}
                      />
                    </div>

                    {showError && (
                      <div className="flex justify-center">
                        {" "}
                        <span className="text-sm text-red pt-2">
                          {messageError}
                        </span>{" "}
                      </div>
                    )}

                    <div className="grid justify-items-end pt-8">
                      <div className="grid content-center">
                        <VerifyNewWhatsApp
                          phone={phoneInput}
                          handleSubmitVerifyPhone={handleSubmitVerifyPhone}
                          showViewVerifyOtp={showViewVerifyOtp}
                          toggleShowViewVerifyOtp={toggleShowViewVerifyOtp}
                          disabledBtn={disabledBtn}
                          setOptInput={setOptInput}
                          handleSubmitVerifyOtp={handleSubmitVerifyOtp}
                          showSuccessView={showSuccessView}
                          messageError={messageError}
                          showError={showError}
                          handleClosePanel={handleClosePanel}
                        />
                      </div>
                    </div>

                    <div className={"w-full"}>
                      <div
                        className="cursor-pointer min-w-full"
                        onClick={handleSubmitVerifyPhone}
                      >
                        <div className="flex justify-end">
                          <PrimaryMobile
                            disabled={disabledBtn}
                            /* text={"Enviar invitación"} */
                            icon={<ArrowRightIcon className="w-6 h-auto" />}
                          />
                        </div>
                      </div>
                    </div>
                    {isLoading && (
                      <div
                        className="p-3 text-grayP"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div className="loader-clousure-movements"> </div>
                        </div>
                        Validando tu información...
                      </div>
                    )}

                    {showSuccessView && (
                      <div className="grid justify-items-end pt-8">
                        <div className="grid content-center">
                          <TYPUpdate
                            showSuccessView={showSuccessView}
                            handleClosePanel={handleClosePanel}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
